import styled from '@emotion/styled';
import { MouseEventHandler } from 'react';

import Icon from '../icons/icon';
import { IconProps } from '../icons/icon';

type PropsType = {
    className?: string;
    onClick?: MouseEventHandler;
    iconSize?: IconProps['size'];
};

const Background = styled.div`
    border-radius: 100%;
    height: ${(props) => props.theme.spacing.xxl};
    width: ${(props) => props.theme.spacing.xxl};
    background: ${(props) => props.theme.palette.background.paper};
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    font: ${(props) => props.theme.fonts.body};
    & > * {
        margin-inline-start: 3px;
    }
`;

const PlayButton = ({
    className,
    onClick = undefined,
    iconSize,
}: PropsType) => {
    return (
        <Background className={className} onClick={onClick}>
            <Icon name='play_arrow' size={iconSize} />
        </Background>
    );
};

export default PlayButton;
